import { Controller } from '@hotwired/stimulus';
import { runWhenDomLoaded } from '@frontend/utils/dom';

export default class extends Controller {
  static values = {
    width: { type: String, default: 'auto' },
    height: { type: String, default: 'auto' },
  };

  connect() {
    runWhenDomLoaded(() => {
      const iframe = window.frameElement;
      if (iframe) {
        iframe.allowTransparency = true;
        iframe.frameBorder = 0;
        const body = this.element;
        const iframeContentHeight = body.scrollHeight + 'px';
        iframe.style.height =
          this.heightValue === 'auto' ? iframeContentHeight : this.heightValue;

        if (this.widthValue !== 'auto') {
          iframe.style.width = this.widthValue;
        }
      }
    });
  }
}
